import axios from "axios";

// API key constant
const API_KEY =
  "uEbwWdT5hhgikMjeSfOf5UwxnK9fPZRMveP5t3lFEyuR7rlKlixSs53wlrU9Vj9zsbnVCrlkrbCzcIap7hmjgjcGFPXcFNzELRb0dG3LrL2TWGkuKJH88QrCtLtsg0fw";

// Create axios instance with common headers
const api = axios.create({
  headers: {
    "x-api-key": API_KEY,
    "Content-Type": "application/json",
    Accept: "application/json",
    "Api-Version": "v1",
  },
});

// Process payment via Stripe
export const processStripePayment = async (paymentData, token) => {
  try {
    const response = await api.post(
      "https://app.foodiary.app/api/app/coach/stripe",
      paymentData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key":
            "uEbwWdT5hhgikMjeSfOf5UwxnK9fPZRMveP5t3lFEyuR7rlKlixSs53wlrU9Vj9zsbnVCrlkrbCzcIap7hmjgjcGFPXcFNzELRb0dG3LrL2TWGkuKJH88QrCtLtsg0fw",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Stripe payment error:", error);
    throw error;
  }
};

// Create user info
export const createUserInfo = async (userData, token) => {
  try {
    const response = await api.post(
      "https://app.foodiary.app/api/user-info/create",
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key":
            "uEbwWdT5hhgikMjeSfOf5UwxnK9fPZRMveP5t3lFEyuR7rlKlixSs53wlrU9Vj9zsbnVCrlkrbCzcIap7hmjgjcGFPXcFNzELRb0dG3LrL2TWGkuKJH88QrCtLtsg0fw",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("User info creation error:", error);
    throw error;
  }
};

// Record conversion for affiliate tracking
export const recordConversion = async (conversionData, token) => {
  try {
    const response = await axios.post(
      "https://api.tapfiliate.com/1.6/conversions/",
      conversionData,
      {
        headers: {
          "Content-Type": "application/json",
          "Api-Key": "3acc178a1eff97b14cc1b12c00222e070a3a1b91",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Conversion tracking error:", error);
    throw error;
  }
};
export const updateUserInfo = async (userData, token) => {
  try {
    const response = await api.post(
      "https://app.foodiary.app/api/user/address/update",
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key":
            "uEbwWdT5hhgikMjeSfOf5UwxnK9fPZRMveP5t3lFEyuR7rlKlixSs53wlrU9Vj9zsbnVCrlkrbCzcIap7hmjgjcGFPXcFNzELRb0dG3LrL2TWGkuKJH88QrCtLtsg0fw",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("User info creation error:", error);
    throw error;
  }
};
export const joinChallenge = async (userData, token) => {
  try {
    const response = await api.post(
      "https://app.foodiary.app/api/app/challenge/join",
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key":
            "uEbwWdT5hhgikMjeSfOf5UwxnK9fPZRMveP5t3lFEyuR7rlKlixSs53wlrU9Vj9zsbnVCrlkrbCzcIap7hmjgjcGFPXcFNzELRb0dG3LrL2TWGkuKJH88QrCtLtsg0fw",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("User info creation error:", error);
    throw error;
  }
};

// Get payment amount based on plan and frequency
export const getPaymentAmount = (plan, frequency) => {
  if (plan === "pro") {
    return frequency === "monatlich" ? 150.0 : 450.0;
  } else {
    // plus plan
    return frequency === "monatlich" ? 50.0 : 150.0;
  }
};

// Format payment data for Stripe API
export const formatStripePaymentData = (
  userId,
  trainerId,
  plan,
  frequency,
  amount
) => {
  return {
    currency: "eur",
    amount: amount,
    userID: userId,
    trainerID: trainerId,
    date: getDateOneYearFromNow(),
    subscribe_status: plan.toUpperCase() + "-USER",
    payment_type:
      frequency === "monatlich" ? "Monthly payment" : "One-time payment",
  };
};

// Format conversion data for affiliate tracking
export const formatConversionData = (
  userEmail,
  userId,
  amount,
  plan,
  userData,
  coachName,
  coachEmail,
  FranchiseID,
  ipAddress
) => {
  return {
    customer_id: userEmail,
    external_id: userId,
    amount: amount,
    currency: "EUR",
    commission_type: `coaching-${plan}`,
    commission_name: `Coaching ${plan.toUpperCase()}`,
    meta_data: {
      Source_vom_Klient: "Health-Analyse Closing",
      vorname_klient: userData.firstName || "",
      nachname_klient: userData.lastName || "",
      email_klient: userEmail,
      FranchiseID: FranchiseID,
      email_coach: coachEmail,
      fullname_coach: coachName,
      user_agent: navigator.userAgent,
      ip: ipAddress,
      landing_page: window.location.href,
    },
  };
};

// Helper to generate date one year from now
const getDateOneYearFromNow = () => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 1);
  return date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
};
